import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../../../../endPoints/endPoints";
import { IContractor } from "./IContracor";

export const contractorsApi = createApi({
  reducerPath: "contarctors",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.CONTRACTORS,
  }),
  tagTypes: ["contractors", "contractor"],
  endpoints: (builder) => ({
    getFilteredContractors: builder.query<any, string>({
      query(searchParams) {
        return {
          url: `/pagination?${searchParams}`,
        };
      },
      providesTags: ["contractors"],
    }),
    getAllContractors: builder.query<IContractor[], void>({
      query() {
        return {
          url: "",
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["contractors"],
    }),
    addContractor: builder.mutation<any, Omit<IContractor, "id">>({
      query(body) {
        return {
          url: "",
          method: "POST",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["contractors"],
    }),
    getContractor: builder.query<IContractor, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["contractor"],
    }),
    editContractor: builder.mutation<IContractor, IContractor>({
      query({ id, ...body }) {
        return {
          url: `/${id}`,
          method: "PUT",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["contractor", "contractors"],
    }),
    deleteContractor: builder.mutation<string, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
          credentials: "include",
        };
      },
      invalidatesTags: ["contractors"],
    }),
  }),
});

export const {
  useAddContractorMutation,
  useDeleteContractorMutation,
  useEditContractorMutation,
  useGetAllContractorsQuery,
  useGetContractorQuery,
  useGetFilteredContractorsQuery,
} = contractorsApi;
